import { createValidIcon } from './utils/type-helper'

export const PencilIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.382 3.51195C15.7837 3.38143 16.2164 3.38143 16.6181 3.51195C16.9075 3.60598 17.1291 3.76536 17.3036 3.91347C17.4625 4.04831 17.6358 4.22162 17.8134 4.3993L19.5983 6.18416C19.7768 6.36261 19.9506 6.53641 20.0858 6.69564C20.2342 6.87047 20.3938 7.09239 20.488 7.38215C20.6185 7.7839 20.6184 8.21659 20.4879 8.61822C20.3939 8.9078 20.2344 9.12959 20.0861 9.30432C19.951 9.46342 19.7774 9.63703 19.5991 9.8152L19.5674 9.84693L10.4142 19.0001H20C20.5523 19.0001 21 19.4478 21 20.0001C21 20.5524 20.5523 21.0001 20 21.0001H4.00001C3.44772 21.0001 3 20.5524 3 20.0001V16.0001C3 15.7349 3.10536 15.4805 3.29289 15.293L11.2929 7.29301L14.1665 4.41941L14.1858 4.40013C14.3637 4.22218 14.5371 4.04868 14.6961 3.91372C14.8707 3.76551 15.0925 3.60603 15.382 3.51195ZM12 9.41433L5 16.4143V19.0001L7.58578 19.0001L14.5858 12.0001L12 9.41433ZM16 10.5859L18.1707 8.41515C18.3748 8.21103 18.4868 8.09785 18.5613 8.01002C18.5643 8.00657 18.567 8.00327 18.5696 8.00015C18.567 7.99694 18.5641 7.99356 18.5611 7.99001C18.4854 7.90081 18.3712 7.7855 18.1615 7.57583L16.4217 5.83603C16.2129 5.62721 16.0982 5.51358 16.0094 5.43824C16.0061 5.43547 16.003 5.43285 16 5.43037C15.997 5.43291 15.9938 5.4356 15.9904 5.43845C15.9015 5.51393 15.7866 5.62777 15.5775 5.83687L15.5725 5.84181L13.4142 8.00011L16 10.5859Z'
        fill={color}
      />
    </svg>
  )
})
